var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChampions = function SvgChampions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eef755",
    stroke: "#fff",
    strokeWidth: 2,
    d: "m9.413 1.876-2.3 4.655-5.136.749a1.126 1.126 0 0 0-.618 1.92l3.716 3.62-.879 5.115a1.124 1.124 0 0 0 1.631 1.185l4.595-2.42 4.595 2.42a1.125 1.125 0 0 0 1.631-1.185l-.879-5.115 3.716-3.62a1.126 1.126 0 0 0-.622-1.92l-5.141-.749-2.3-4.655a1.126 1.126 0 0 0-2.009 0z",
    "data-name": "Path 456"
  })));
};
export default SvgChampions;